import { render, staticRenderFns } from "./base-list-item.vue?vue&type=template&id=412bfe4a&scoped=true&"
import script from "./base-list-item.vue?vue&type=script&lang=js&"
export * from "./base-list-item.vue?vue&type=script&lang=js&"
import style0 from "./base-list-item.vue?vue&type=style&index=0&id=412bfe4a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412bfe4a",
  null
  
)

export default component.exports